import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ArrowCircleLeft = (props: SvgIconT.Props) => (
  <SvgIcon width={28} height={28} {...props} viewBox="0 0 28 28">
    <path d="M14 0c7.732 0 14 6.268 14 14s-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0Zm0 1C6.82 1 1 6.82 1 14s5.82 13 13 13 13-5.82 13-13S21.18 1 14 1Zm-.38 6.216a1 1 0 0 1 .236 1.302l-.072.103L10.316 13H21a1 1 0 0 1 .117 1.993L21 15H10.317l3.467 4.38a1 1 0 0 1-.07 1.32l-.093.084a1 1 0 0 1-1.321-.07l-.084-.093L6.975 14l5.241-6.62a1 1 0 0 1 1.405-.164Z" />
  </SvgIcon>
);

export default ArrowCircleLeft;
